import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Analytics from './../../analytics';
import * as uuid from "uuid";

export default class Quantity extends Component {

  static propTypes = {
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    title: PropTypes.string,
    label: PropTypes.string,
    size: PropTypes.string,
    changeValue: PropTypes.func.isRequired,
    minValue: PropTypes.number,
    maxValue: PropTypes.number,
    defaultQuantity: PropTypes.number,
    hideQuantity: PropTypes.bool,
    pulseFeatureInfoQuantity: PropTypes.bool,
    squared: PropTypes.bool,
    allowDecimals: PropTypes.bool
  };

  static defaultProps = {
    hideQuantity: false,
    pulseFeatureInfoQuantity: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      value: props.defaultQuantity || props.value,
      inputId: uuid.v4()
    };
  }

  componentDidMount() {

  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.value !== this.state.value) {
      this.setState({
        value: nextProps.value
      })
    }
  }

  getMinMax = () => {
    const min = this.props.minValue !== undefined ? this.props.minValue : 0;
    const max = this.props.maxValue !== undefined ? this.props.maxValue : 99999;

    return {min, max};
  };

  handleOnKeyDown = (event) => {
    if (event.key==='.' && !this.props.allowDecimals) {
      event.preventDefault();
      return false
    }
  };

  handleChangeValue = (event, button) => {
    let value = "" + (button ? this.state.value + event : +event.target.value);
    if (value.includes(".")) {
      if (!this.props.allowDecimals) {
        return false
      }
      if (value.split(".")[1].length > 2) {
        value = +value.substring(0, value.length - 1); //round to 2 decimals
      }
    }
    value = +value;
    Analytics.sendDataEnteredEvent("quantity-value", value);
    const {min, max} = this.getMinMax();
    if (value >= min && value <= max) {
      value = value === 0 ? "" : value;
      this.setState({value});
      this.props.changeValue(value);
    }
  };

  handleInputBlur = (e,) => {
    const value = +e.target.value;
    const {min, max} = this.getMinMax();
    if (value >= min) {
      this.setState({value});
      this.props.changeValue(value);
    } else {
      this.setState({value: 0});
      this.props.changeValue(0);
    }
    if (value > max) {
      this.setState({value: max});
      this.props.changeValue(max);
    }
  };

  getColor = () => {

    if (this.props.pulseFeatureInfoQuantity) {
      return "pulsing-red"
    }

    const {min, max} = this.getMinMax();
    return (this.state.value > min && this.state.value <= max) ? "green" : "blue"
  };

  render() {
    const {hideQuantity, squared} = this.props;
    const color = this.getColor();
    return (
      <div className={"ui-quantity" + (color ? " ui-quantity--" + color : "") + " ui-quantity--" + this.props.size}>
        {this.props.title ? <span className="ui-quantity__title">{this.props.title}</span> : null}
        {this.props.label ? <label htmlFor={this.state.inputId} className="ui-quantity__label">{this.props.label}</label> : null}
        <div className={"ui-quantity__body"
        + (hideQuantity ? " ui-quantity__body--readonly" : "")
        + (squared ? " ui-quantity__body--squared" : "")}>
          {hideQuantity
            ? null
            : (<button className="ui-quantity-button ui-quantity-button--minus"
                       onClick={() => this.handleChangeValue(-1, true)}>-
            </button>)}
          <input type="number"
                 className="ui-quantity-input"
                 value={this.state.value}
                 onChange={this.handleChangeValue}
                 onKeyDown={this.handleOnKeyDown}
                 onBlur={this.handleInputBlur}
                 id={this.state.inputId}
                 readOnly={hideQuantity}/>
          {hideQuantity
            ? null
            : (<button className="ui-quantity-button ui-quantity-button--plus"
                       onClick={() => this.handleChangeValue(+1, true)}>+
            </button>)}
        </div>
      </div>
    );
  }
}
